import useAuth from '../../component/useAuth';
import Template from '../../component/Template';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React, { useRef } from "react";

import { Link } from 'react-router-dom';
import logo from "../../Assets/images/gif/danger.gif";


import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { useNavigate } from 'react-router-dom';

export default function Discipline() {

  const navigate = useNavigate();
  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/admin/")
  }



  const [faculty, setFacultyData] = useState([]);
  const [discipline, setDisciplineData] = useState([]);

  const [isDelete, setDelete] = useState(false);
  const [deleteid, setDeleteid] = useState(false);
  const [istost, settost] = useState(false);
  const tableRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort

  const [selectedFacultyId, setSelectedFacultyId] = useState(null);

  //21/3/2024
  const [showModal, setShowModal] = useState(false); // State to control modal visibility 
  const [selectedFaculty, setSelectedFaculty] = useState(null); // State to store selected faculty
  const [selectedDname, setSelectedDName] = useState(null);
  const [selectedDdate, setSelectedDDate] = useState(null);
  const [selectedDrem, setSelectedDRem] = useState(null);
  const [selectedDcode, setSelectedDCode] = useState(null);

  const [totaldiscipline, setTotalDiscipline] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
  const [isAccess, setAccess] = useState({
    addDiscipline: false,
    viewDiscipline: false,
    updateDiscipline: false,
    deleteDiscipline: false
  });

  // Function to handle sorting-sort05/03/2024
  const handleSort = (column) => {
    const newSortBy = {
      column,
      direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
    };
    setSortBy(newSortBy);
  };

  //for filter
  const handleFacultyChange = (event) => {
    setSelectedFacultyId(event.target.value);
  };


  // Sort userlog based on sortBy state-sort05/03/2024
  const disciplinedata = [...discipline].sort((a, b) => {
    if (sortBy.direction === 'asc') {
      return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
    } else {
      return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
    }
  });


  // Function to render sort icon-sort05/03/2024
  const renderSortIcon = (columnName) => {
    if (sortBy.column === columnName) {
      return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
    }
    return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
  };

  //excel dowload
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: 'Faculty Database',
    sheet: 'Faculty',
  });

  //role validation
  useEffect(() => {
    const access = async () => {
      const { http } = Api();
      const id = localStorage.getItem("id");
      try {
        const response = await http.get('/Admin/get-all-user-permissions', { params: { user_id: id } });
        const permissions = response.data.map(permission => permission.name);

        const hasAddPermission = permissions.includes("add-discipline");
        const hasViewPermission = permissions.includes("view-discipline");
        const hasUpdatePermission = permissions.includes("update-discipline");
        const hasDeletePermission = permissions.includes("delete-discipline");

        setAccess({
          addDiscipline: hasAddPermission,
          viewDiscipline: hasViewPermission,
          updateDiscipline: hasUpdatePermission,
          deleteDiscipline: hasDeletePermission
        });
      } catch (error) {
        console.error("Error fetching user roles:", error);
      }
    };
    access();
  }, []);


  useEffect(() => {
    if (istost) {
      toast.success(istost);
      sessionStorage.removeItem("message");
      settost(false);
    }
  }, [istost]);


  useEffect(() => {
    fetchData();
    settost(sessionStorage.getItem("message"));
  }, [currentPage, selectedFacultyId]);

  const fetchData = async () => {
    try {
      const { http } = Api();
      const response = await http.get(`/Admin/getfaculty`);
      const response1 = await http.get(`/Admin/getdiscipline?page=${currentPage}`, {
        params: {
          limit: '50',
          faculty_id: selectedFacultyId
        }
      });
      // Check if the response contains data
      if (response.data.data && response1.data.data) {
        setDisciplineData(response1.data.data);
        setFacultyData(response.data.data);
        setTotalPages(Math.ceil(response1.data.total / 50));
        setTotalDiscipline(response1.data.total);
      } else {

        console.error('Server response did not contain any data');
        setDisciplineData([]);

      }
    } catch (error) {
      console.error('Error fetching data:', error);
      // Handle error state or display an error message to the user
    }
  };


  const handleDeleteSuccess = async () => {
    const { http } = Api();
    try {
      const response = await http.delete(`Admin/deletediscipline/${deleteid}`);
      console.log(response);
      if (response.data.status_code === "MSG3") {
        setDelete(false);
        sessionStorage.setItem("message", " Discipline deleted successfully!")
        window.location.reload();
      }
    } catch (error) {
      toast.error("Something went wrong"); // Show error toast
      console.error('Error deleting faculty:', error);
    }
  }

  const encodeID = id => {
    return btoa(id);
  };

  const handleDelete = (id) => {
    setDeleteid(id);
    setDelete(true);
  }

  const handleCancel = () => {
    setDelete(false);
  }

  const handleExportDropdownToggle = (event) => {
    const selectedValue = event.target.value;
    if (selectedValue === "1") {
      // Handle PDF conversion
    } else if (selectedValue === "2") {
      // Handle CSV conversion
    } else if (selectedValue === "3") {
      onDownload();
    }
  };
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  //21/3/2024
  // Function to open modal and set selected faculty
  const handleViewModalOpen = (fname, dcode, dname, ddate, drem) => {
    setSelectedFaculty(fname);
    setSelectedDCode(dcode);
    setSelectedDName(dname);
    setSelectedDRem(drem);
    setSelectedDDate(ddate);
    setShowModal(true);
  };

  // Function to close modal
  const handleModalClose = () => {
    setShowModal(false);
  };
  const handleSearchInputChange = (event) => {
    //console.log(event.target.value+"onchange");
    setSearchQuery(event.target.value);
  };

  //21/3/2024
  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year}, ${hour}:${minute}`;
  }


  useEffect(() => {
    const filteredAndSortedData = [...discipline].filter(disciplines => {
      return (
        (selectedFacultyId === null || disciplines.faculty_id === selectedFacultyId) && // Check if selected faculty matches
        disciplines.discipline_code.toLowerCase().includes(searchQuery.toLowerCase()) ||
        disciplines.discipline_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        disciplines.status.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }).sort((a, b) => {
      if (sortBy.direction === 'asc') {
        return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
      } else {
        return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
      }
    });
    setfilteredAndSortedData(filteredAndSortedData);
  }, [searchQuery, sortBy, discipline, selectedFacultyId]);


  const [showFilter, setShowFilter] = useState(false); // State to control filter section visibility
  const toggleFilter = () => {
    setShowFilter(!showFilter); // Toggle filter section visibility
  };

  const closeFilter = () => {
    setShowFilter(false); // Close filter section
  };

  const [ismobile, setIsmobile] = useState(false);
  const togglemenu = () => {
      setIsmobile(!ismobile);
  };

  return (
    <>
      <ToastContainer />
      <Template>

        <div className={`modal fade show ${showModal ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <div className="modal-toggle-wrapper">

                  <h6> Discipline : {selectedDname}</h6>
                  <div class="d-flex mt-3">

                    <div class="flex-grow-1 ms-2">
                      <p><i class="fa fa-thumb-tack" aria-hidden="true"></i> Discipline Code : {selectedDcode}</p>
                      <p><i class="fa fa-thumb-tack" aria-hidden="true"></i> Faculty : {selectedFaculty}</p>
                      <p><i class="fa fa-thumb-tack" aria-hidden="true"></i> Created Date : {selectedDdate}</p>
                      <p><i class="fa fa-thumb-tack" aria-hidden="true"></i> Remarks : {selectedDrem === 'Null' ? '' : selectedDrem}</p>
                    </div>
                  </div>

                  <center>
                    <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleModalClose()}>Cancel</button>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className={`modal fade show ${isDelete ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-body">
                <div className="modal-toggle-wrapper">
                  <ul className="modal-img">
                    <li> <img src={logo} /></li>
                  </ul>
                  <h4 className="text-center pb-2">Are you sure you want to delete?</h4>
                  <p className="text-center">This action cannot be undone. Please confirm if you want to proceed with the deletion.</p>
                  <div className="d-flex justify-content-center mt-3">
                    <button className="btn btn-danger mx-2" onClick={() => handleDeleteSuccess()}>Delete</button>
                    <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleCancel()}>Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header card-heading">
                  <div className="py-3 d-flex justify-content-between align-items-center">
                    <h5 className="lbl1">Discipline</h5>
                    <div className="d-flex ml-auto">
                      {/* Responsive Dropdown or Hamburger Menu */}
                      <div className="dropdown d-lg-none">
                        <button
                          className="btn btn-light dropdown-toggle"
                          type="button"
                          id="mobileActionsDropdown"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded={ismobile}
                          onClick={togglemenu}
                        >
                          <i className="fas fa-bars"></i>
                        </button>
                        <div
                          className={`dropdown-menu dropdown-menu-right ${ismobile ? 'show' : ''}`}
                          aria-labelledby="mobileActionsDropdown"
                          style={{
                            margin: '10px 20px 20px -60px',
                            boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                            borderRadius: '0.5rem',
                            overflow: 'hidden',
                            color: 'black',
                          }}
                        >
                          <a
                            className="dropdown-item"
                            onClick={() => {
                              toggleFilter();
                              togglemenu();
                            }}
                          >
                            <i
                              className={`bi ${showFilter ? 'bi-x-circle-fill' : 'bi-funnel-fill'} show`}
                              aria-hidden="true"
                              style={{ cursor: "pointer", color: 'black' }}
                            > Filter</i>
                          </a>
                          <div className="dropdown-divider my-0"></div>
                          <div className="dropdown-item py-3">
                            <select
                              className="form-select btn-border"
                              id="inputGroupSelect01"
                              onChange={handleExportDropdownToggle}
                              style={{ cursor: "pointer" }}
                            >
                              <option selected="">Export As</option>
                              <option value="1">Pdf</option>
                              <option value="2">Csv</option>
                              <option value="3">Excel</option>
                            </select>
                          </div>
                          <div className="dropdown-divider my-0"></div>
                          {isAccess.addDiscipline && (
                            <Link className="dropdown-item" to="/admin/disciplineadd">
                              <i
                                className="bi bi-plus-circle-fill show"
                                style={{ cursor: "pointer", color: 'black' }}
                              > Add New</i>
                            </Link>
                          )}
                        </div>
                      </div>


                      {/* Desktop View */}
                      <div className="d-none d-lg-flex">
                        <div className="light-box">
                          <a style={{ marginLeft: "10px" }} onClick={toggleFilter} className="btn btn-light">
                            <i className={`fa fa-filter ${showFilter ? 'icon-close' : 'filter-icon'} show`} aria-hidden="true"></i>
                          </a>
                          &nbsp;&nbsp;
                        </div>
                        <div className="form-group">
                          <select className="form-select btn-border" id="inputGroupSelect01" onChange={handleExportDropdownToggle} style={{ cursor: "pointer" }}>
                            <option selected="">Export As</option>
                            <option value="1">Pdf</option>
                            <option value="2">Csv</option>
                            <option value="3">Excel</option>
                          </select>
                        </div>
                        &nbsp;&nbsp;
                        {isAccess.addDiscipline && (
                          <Link className="btn btn-primary form-group" to="/admin/disciplineadd">
                            <span className="icon">&#43;</span>
                            <div className="txtsh"> Add New</div>
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className={`collapse ${showFilter ? 'show' : ''}`} id="collapseProduct" style={{ margin: "20px 20px 20px 20px" }}>
                  <div className="card card-body list-product-body">
                    {/*23/3/2024-filter*/}
                    <div className="row row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-2 g-3">
                      <div className="col">
                        <select className="form-select" aria-label="Default select example" defaultValue={selectedFacultyId} onChange={handleFacultyChange}>
                          <option value={null}>Select Faculty</option>
                          {faculty.map(facultys => (
                            <option value={facultys.id} key={facultys.id}>{facultys.faculty_name}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col">
                        <button className="btn btn-primary" onClick={() => window.location.reload()} style={{ width: "100%" }}>Clear All</button>
                      </div>
                    </div>
                  </div>
                </div>

                {isAccess.viewDiscipline ? (
                  <div className="card-body">
                    <div className="card-body pdg1">
                      <div className="table-responsive ovrflw">

                        <div className='row'>
                          <div className='col-md-6 wdt' >
                            <p>
                              Showing {(currentPage - 1) * 50 + 1}{''}-
                              {Math.min((currentPage - 1) * 50 + 50, totaldiscipline)} of {totaldiscipline} entries
                            </p>
                          </div>
                          <div className='col-md-6 wdt'>
                            <input
                              type="text"
                              value={searchQuery}
                              onChange={handleSearchInputChange}
                              placeholder="Search..."
                              className='form-control'

                            />
                          </div>
                        </div>

                        <table className="display dataTable table-striped table-bordered" ref={tableRef}>
                          <thead>
                            <tr className="bg-primary">
                              <th onClick={() => handleSort('created_at')}>Sl No &nbsp;
                                {renderSortIcon('created_at')}</th>
                              <th onClick={() => handleSort('discipline_code')}>Discipline Code &nbsp;
                                {renderSortIcon('discipline_code')}</th>
                              <th onClick={() => handleSort('discipline_name')}>Discipline &nbsp;
                                {renderSortIcon('discipline_name')}</th>
                              <th onClick={() => handleSort('faculty_name')}>Faculty Name &nbsp;
                                {renderSortIcon('discipline_name')}</th>
                              <th onClick={() => handleSort('created_at')}>Created date &nbsp;
                                {renderSortIcon('created_at')}</th>

                              <th onClick={() => handleSort('status')}>Status &nbsp;
                                {renderSortIcon('status')}</th>
                              {(isAccess.deleteDiscipline || isAccess.updateDiscipline || isAccess.viewDiscipline) && (
                                <th>Action</th>
                              )}
                            </tr>
                          </thead>
                          <tbody>

                            {filteredAndSortedData.length > 0 ? (
                              filteredAndSortedData.map((disciplines, index) => {
                                if (disciplines.status !== 'deleted') {
                                  const serialNumber = (currentPage - 1) * 50 + index + 1;

                                  return (
                                    <tr key={disciplines.faculty_code}>
                                      <td>{serialNumber}</td>
                                      <td>{disciplines.discipline_code}</td>
                                      <td>{disciplines.discipline_name}</td>
                                      <td>{disciplines.faculty_name}</td>
                                      <td>{formatDate(disciplines.created_at)}</td>
                                      {/*<td>{disciplines.faculty_name}</td>
          <td>{disciplines.remarks === 'Null' ? '' : disciplines.remarks}</td>*/}
                                      <td>{disciplines.status}</td>
                                      <td>
                                        <ul className="action">
                                          {isAccess.updateDiscipline && (
                                            <li className="edit"> <Link to={`/admin/disciplineedit/${encodeID(disciplines.id)}`}><i className="icon-pencil-alt"></i></Link></li>
                                          )}
                                          {isAccess.deleteDiscipline && (
                                            <li className="delete"><div style={{ cursor: "pointer" }} onClick={() => handleDelete(disciplines.id)}><i className="icon-trash"></i></div></li>
                                          )} &nbsp;
                                          {isAccess.viewDiscipline && (
                                            <li className="view">
                                              <span className="icon-eye" style={{ cursor: "pointer" }} onClick={() => handleViewModalOpen(disciplines.faculty_name, disciplines.discipline_code, disciplines.discipline_name, formatDate(disciplines.created_at), disciplines.remarks)}></span>
                                            </li>
                                          )}
                                        </ul>
                                      </td>
                                    </tr>
                                  );
                                } else {
                                  return null; // Skip rendering for deleted data
                                }
                              })
                            ) : (
                              <tr><td className="txt-aln" colspan="7" >No Data Available</td></tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      {totalPages > 1 && (
                        <nav aria-label="..." style={{ cursor: "pointer" }}>
                          <ul className="pagination justify-content-center">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                              <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                            </li>
                            <li className={`page-item`}>
                              <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                            </li>
                            {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                            {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                              <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                              </li>
                            ))}
                            {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                            <li className={`page-item`}>
                              <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                            </li>

                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                              <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                            </li>
                          </ul>
                        </nav>
                      )}

                    </div>
                  </div>
                ) : (
                  <div className="card-body">
                    <div className="card-body pdg1">
                      <div className="table-responsive">
                        YOU DONT HAVE ACCESS TO VIEW THIS
                      </div>
                    </div>
                  </div>

                )}
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
